/* eslint-disable no-restricted-syntax */
/* eslint-disable react/prop-types */
/* eslint-disable import/prefer-default-export */
import React, { useState } from 'react'
import { ListingCard } from 'components/listings/cards/Listings/components/ListingCard'
import styles from './PaginatedListing.module.css'

export function PaginatedListing({ data = [], votes = [], pageLimit = 10, signedIn, collectionId }) {
  const [currentPage, setCurrentPage] = useState(1)

  const totalPages = Math.ceil(data.length / pageLimit)
  const shouldPaginate = totalPages > 1

  const start = (currentPage - 1) * pageLimit
  const currentData = data.slice(start, start + pageLimit)

  const handlePageClick = (pageNumber) => {
    setCurrentPage(pageNumber)
  }

  const handlePrevious = () => {
    setCurrentPage((prev) => Math.max(prev - 1, 1))
  }

  const handleNext = () => {
    setCurrentPage((prev) => Math.min(prev + 1, totalPages))
  }

  const getPageNumbers = () => {
    const pages = new Set()

    pages.add(1)
    pages.add(totalPages)
    pages.add(currentPage)

    if (currentPage - 1 > 1) pages.add(currentPage - 1)
    if (currentPage + 1 < totalPages) pages.add(currentPage + 1)

    const sortedPages = [...pages].sort((a, b) => a - b)

    const result = []
    let prev = 0
    for (const page of sortedPages) {
      if (prev && page - prev > 1) {
        result.push(`ellipsis-${page}`)
      }
      result.push(page)
      prev = page
    }

    return result
  }

  return (
    <div className={styles.root}>
      <div className={styles.cardList}>
        {currentData?.map((listing) => {
          const listingVotes = votes?.find((vote) => vote.listing_id === listing.id)
          return (
            <ListingCard
              key={listing.id}
              listing={listing}
              signedIn={signedIn}
              collectionId={collectionId}
              votes={listingVotes}
            />
          )
        })}
      </div>

      {shouldPaginate && (
        <div className={styles.pagination}>
          <button type="button" onClick={handlePrevious} disabled={currentPage === 1} className={styles.pageButton}>
            Previous
          </button>

          {getPageNumbers().map((page) =>
            typeof page === 'string' ? (
              <span key={page} className={styles.ellipsis}>
                ...
              </span>
            ) : (
              <button
                type="button"
                key={page}
                onClick={() => handlePageClick(page)}
                className={`${styles.pageButton} ${page === currentPage ? styles.pageButtonActive : ''}`}
              >
                {page}
              </button>
            )
          )}

          <button
            type="button"
            onClick={handleNext}
            disabled={currentPage === totalPages}
            className={styles.pageButton}
          >
            Next
          </button>
        </div>
      )}
    </div>
  )
}
